import {
  Contract,
} from "../../../../api";
import UpdatedFilesList from "./v2";
import FilesList from "./v1";

interface props {
  contract: Contract;
}

const ContractFilesList = (p : props) => {
  /*const { id } = useParams();
  const [contract, setContract] = useState<Contract | null>(null);
  const [loading, setLoading] = useState(true);

  const getContract = useCallback(async () => {
    if (!id) return;

    const httpContract = await get<Contract>(`/contracts/${id}`);
    if (httpContract.statusCode === 200) {
      setContract(httpContract.response);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    getContract();
  }, [getContract]);

  if (loading) {
    return <Spin tip="Cargando lista de archivos..." />;
  }*/

  if (!p.contract) {
    return null;
  }

  return <>{p.contract.ver == 1 ? <FilesList contract = {p.contract}/> : <UpdatedFilesList  contract = {p.contract}/>}</>;
};

export default ContractFilesList;
